<!--  -->
<template>
  <div class="message-container">
    <div class="message-form">
      <a-form ref="tableForm">
        <div class="form-body">
          <div class="form-item">
            <a-form-item label="来源">
              <a-select
                v-model:value="modelRef.productCode"
                class="item"
                placeholder="请选择来源"
                allowClear
              >
                <a-select-option
                  v-for="pro in productOption"
                  :key="pro.id"
                  :value="pro.productCode"
                >{{ pro.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="UID">
              <a-input v-model:value="modelRef.uid" placeholder="Basic usage" />
            </a-form-item>
            <a-form-item label="语种">
              <a-select v-model:value="modelRef.lang" class="item" placeholder="请选择语种" allowClear>
                <a-select-option v-for="pro in langData" :key="pro.fullCode">{{ pro.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="留言时间">
              <a-range-picker
                v-model:value="modelRef.time"
                class="item"
                show-time
                :placeholder="['开始时间', '结束时间']"
              >
                <template #dateRender="{ current, today }">
                  <div class="ant-calendar-date">{{ current.date() }}</div>
                </template>
              </a-range-picker>
            </a-form-item>

            <a-form-item label="审批状态">
              <a-select
                v-model:value="modelRef.messageStatus"
                class="item"
                placeholder="请选择留言状态"
                allowClear
              >
                <a-select-option v-for="pro in messageStatus" :key="pro.id">{{ pro.text }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="服务器">
              <a-select
                v-model:value="modelRef.server"
                class="item"
                @change="serveChange"
                placeholder="请选择服务器"
                show-search
                :default-active-first-option="true"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="fetching ? undefined : null"
                @search="fetchServer"
                allowClear
              >
                <a-select-option
                  v-for="pro in serverData"
                  :key="pro.server_id"
                >{{pro.server_id}}:{{pro.server_name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="关键字">
              <a-input v-model:value="modelRef.keyword" placeholder="请输入关键字" />
            </a-form-item>
          </div>
          <!-- <div class="form-drop-down">
            <img src="~@/assets/images/down.svg" class="down" v-if="dropDownStatus" />
            <img src="~@/assets/images/up.svg" class="down" v-if="!dropDownStatus" />
          </div>-->
        </div>
      </a-form>
    </div>
    <div class="message-btn">
      <a-button type="primary" @click="searchBtn('click')" :loading="loadingSearch">查询</a-button>
    </div>
    <div class="message-table">
      <div class="table-btn">
        <a-button
          type="primary"
          class="btn"
          @click="allPassChange"
          :loading="loadingAllPass"
          :disabled="allDisabled"
        >批量通过</a-button>
        <a-button
          type="danger"
          class="btn"
          @click="allRefuseChange"
          :disabled="allDisabled"
          :loading="loadingAllRefuse"
        >批量拒绝</a-button>
      </div>
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 'calc(950px + 50%)', y: 540 }"
        :loading="loading"
        :pagination="false"
      >
        <template #language="{ text }">
          <span v-if="text === 'en'">英语</span>
          <span v-if="text === 'ru'">俄语</span>
          <span v-if="text === 'es'">西语</span>
          <span v-if="text === 'pt'">葡语</span>
          <span v-if="text === 'de'">德语</span>
          <span v-if="text === 'fr'">法语</span>
        </template>
        <template #status="{ text }">
          <span v-if="text ===0" class="status">未审批</span>
          <span v-if="text ===1" class="status-green">已通过</span>
          <span v-if="text ===2" class="status-red">已拒绝</span>
        </template>
        <template #text="{ text }">
          <span class="txt">
            <a-tooltip :title="text">{{text}}</a-tooltip>
          </span>
        </template>
        <template #roleName="{ text }">
          <span class="txt">
            <a-tooltip :title="text">{{text}}</a-tooltip>
          </span>
        </template>
        <template #images="{ text }">
          <div class="table-img">
            <img :src="item" v-for="(item,index) in text" :key="index" class="img" />
          </div>
        </template>
        <template #actionStatus="{ text,record }">
          <span v-if="text === 0">
            <a-popconfirm
              title="确定要进行通过操作吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="popConfirm(1,record)"
            >
              <a>通过</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定要进行拒绝操作吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="popConfirm(2,record)"
            >
              <a class="status-red">拒绝</a>
            </a-popconfirm>
          </span>
          <span v-if="text === 1">
            <a-popconfirm
              title="确定要修改为拒绝吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="popConfirm(2,record)"
            >
              <a class="red">修改为拒绝</a>
            </a-popconfirm>
          </span>
          <span v-if="text === 2">
            <a-popconfirm
              title="确定要修改为通过吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="popConfirm(1,record)"
            >
              <a class="green">修改为通过</a>
            </a-popconfirm>
          </span>
          <a-divider type="vertical" />
          <a @click="edit(record)">详情</a>
        </template>
      </a-table>
      <div class="page">
        <a-pagination
          :total="total"
          :show-total="total => `Total ${total} items`"
          :page-size="pageData.pageSize"
          v-model:current="pageData.current"
          @change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  onMounted,
  defineComponent,
  computed,
  toRefs,
  watch
} from "vue";
import {
  serversList,
  messageStatus,
  messageList,
  getProductsList
} from "@/api/index.js";
import { useStore } from "vuex";
import moment from "moment";
import { message } from "ant-design-vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup(props, { attrs, slots, emit }) {
    //common
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      loading: false,
      data: [],
      langData: [],
      serverData: [],
      currentCode: "",
      fetching: false,
      messageStatus: [
        {
          id: 0,
          text: "未审批"
        },
        {
          id: 1,
          text: "已通过"
        },
        {
          id: 2,
          text: "已拒绝"
        }
      ],
      tableData: [
        {
          id: 1
        }
      ],
      productOption: [],
      loading: false,
      loadingSearch: false,
      loadingAllPass: false,
      loadingAllRefuse: false,
      total: 0,
      selectedRowKeys: [],
      allDisabled: true,
      server_name: "",
      dropDownStatus: false
    });
    let selectAll = [];

    const modelRef = reactive({
      lang: null,
      server: null,
      time: null,
      messageStatus: null
    });
    // pagination
    const pageData = reactive({
      current: 1,
      pageSize: 15,
      filterTotal: 0
    });

    //formitem-serve
    const getServeData = () => {
      let params = {};
      serversList(params, currentGamgeCodeRef.value).then(res => {
        if (res.status === 200) {
          state.serverData = res.data.all;
        }
      });
    };
    const serveChange = item => {
      if (modelRef.server) {
        let a = state.serverData.find(child => child.server_id == item);
        state.server_name = a.server_name;
      } else {
        state.server_name = "";
      }
    };
    const fetchServer = value => {
      value = value.toLowerCase();
      let data = [];
      data = state.serverData.filter(item => {
        let text = [item.server_id, item.server_name, item.display_server_name]
          .join("【】")
          .toLowerCase();
        return text.indexOf(value) > -1;
      });
      state.serverData = data;
    };
    // popConfirm
    const popConfirm = (value, record) => {
      let arr = [];
      arr.push(record.id);
      let params = {
        idArr: arr,
        status: value
      };
      messageStatus(params).then(res => {
        if (res.status === 200) {
          message.success("审核成功！");
          searchBtn();
        }
      });
    };
    //table
    const columns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80
      },
      {
        title: "语种",
        dataIndex: "language",
        slots: { customRender: "language" }
      },
      {
        title: "服务器",
        dataIndex: "server"
      },
      {
        title: "角色名称",
        dataIndex: "roleName",
        slots: { customRender: "roleName" }
      },
      {
        title: "留言内容",
        dataIndex: "text",
        slots: { customRender: "text" }
      },
      {
        title: "留言时间",
        dataIndex: "date"
      },
      {
        title: "上传图片",
        dataIndex: "images",
        slots: { customRender: "images" }
      },
      {
        title: "状态",
        dataIndex: "status",
        slots: { customRender: "status" }
      },
      {
        title: "操作",
        dataIndex: "actionStatus",
        slots: { customRender: "actionStatus" }
      }
    ];
    const onSelectChange = (selectedRowKeys, record) => {
      if (selectedRowKeys.length > 0) {
        state.allDisabled = false;
      } else {
        state.allDisabled = true;
      }
      record.forEach(item => {
        selectAll.push(item.id);
      });
      state.selectedRowKeys = selectedRowKeys;
    };
    const searchBtn = e => {
      if (e === "click") {
        state.loadingSearch = true;
      }
      state.loading = true;
      let params = {
        gameCode: state.currentCode,
        pageNumber: pageData.current
      };
      if (modelRef.lang !== null || modelRef.lang !== undefined) {
        params.language = modelRef.lang;
      }
      if (modelRef.server !== null && state.server_name) {
        params.server = `${modelRef.server}:${state.server_name}`;
      }
      if (modelRef.time !== null && modelRef.time.length > 0) {
        params.beginTime = moment(modelRef.time[0]).unix();
        params.endTime = moment(modelRef.time[1]).unix();
      }
      if (
        modelRef.messageStatus !== null ||
        modelRef.messageStatus !== undefined
      ) {
        params.status = modelRef.messageStatus;
      }
      params = Object.assign({}, params, modelRef);
      console.log(params, "????");
      console.log(modelRef, "????");
      messageList(params).then(res => {
        console.log(res, "??????");
        if (res.status === 200) {
          setTimeout(() => {
            state.loadingSearch = false;
            state.loading = false;
          }, 2000);
          res.data.messages.forEach(item => {
            item.date = moment(item.createdAt * 1000).format(
              "YYYY/MM/DD HH:mm:ss"
            );

            item.actionStatus = item.status;
          });
          state.tableData = res.data.messages;
          state.total = res.data.total;
        }
      });
    };
    const pageChange = () => {
      searchBtn();
      getServeData();
    };
    const allRefuseChange = () => {
      state.loadingAllRefuse = true;
      let params = {
        idArr: selectAll,
        status: 2
      };
      messageStatus(params).then(res => {
        if (res.status === 200) {
          message.success("审核成功！");
          setTimeout(() => {
            state.loadingAllRefuse = false;
          }, 500);
          searchBtn();
          state.selectedRowKeys = [];
          state.allDisabled = true;
        }
      });
    };
    const allPassChange = () => {
      state.loadingAllPass = true;
      let params = {
        idArr: selectAll,
        status: 1
      };
      messageStatus(params).then(res => {
        if (res.status === 200) {
          message.success("审核成功！");
          setTimeout(() => {
            state.loadingAllPass = false;
          }, 500);
          searchBtn();
          state.selectedRowKeys = [];
          state.allDisabled = true;
        }
      });
    };
    const edit = key => {
      console.log(key, "???????djjd");
      router.push({
        name: "messageSearch",
        query: {
          id: key.id
        }
      });
    };
    const getProductChange = async () => {
      const res = await getProductsList({
        gameCode: currentGamgeCodeRef.value
      });
      console.log(res, "????˝");
      state.productOption = res.data.products;
    };
    // store computed
    let langDataRef = computed(() => store.state.settings.languages);
    let currentGamgeCodeRef = computed(
      () => store.state.settings.currentGamgeCode
    );
    watch(
      [currentGamgeCodeRef, langDataRef],
      ([newGameCodeData, newLangData], [preGameCodeData, preLangData]) => {
        if (newGameCodeData) {
          state.currentCode = newGameCodeData;
          searchBtn();
          getServeData();
          getProductChange();
        }
        if (newLangData) {
          let item = {
            fullCode: "0",
            name: "全部"
          };
          state.langData = newLangData;
          if (!state.langData.find(itemC => itemC.fullCode === "0")) {
            state.langData.unshift(item);
          }
        }
      }
    );
    onMounted(() => {
      state.currentCode = currentGamgeCodeRef;
      if (state.currentCode) {
        searchBtn();
        getServeData();
        getProductChange();
      }
    });
    return {
      modelRef,
      columns,
      ...toRefs(state),
      // fun
      onSelectChange,
      searchBtn,
      pageChange,
      allPassChange,
      allRefuseChange,
      serveChange,
      fetchServer,
      pageData,
      popConfirm,
      edit
    };
  }
});
</script>
<style lang="less">
// .item {
//   .ant-form-item-children {
//     width: 100%;

//     .ant-calendar-picker {
//       width: 100%;
//     }
//   }
// }
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.txt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  cursor: pointer;
  width: 160px;
}
.table-img {
  display: grid;
  grid-template-columns: repeat(3, 50px);
  grid-row-gap: 5px;
  grid-column-gap: 5px;
  .img {
    width: 100%;
    height: 100%;
  }
}
@import "./index.less";
</style>